import proj4 from 'proj4';

/**
 * Ustawia definicję w bibliotece proj4 dla zadanego epsg.
 *
 * @param {string} authName - np. EPSG
 * @param {number} authSrid - np. 2180
 * @param {string} proj4text - współrzędne do transformacji
 *
 * @return {void}
 */

const setProj4Definition = (authName, authSrid, proj4text) => {
  const epsgCode = `${authName}:${authSrid}`;
  try {
    proj4.defs(epsgCode, proj4text);
  } catch (err) {
    throw new Error(
      `Nie udało się zdefiniować układu PROJ.4 dla ${epsgCode} !`
    );
  }
};

export default setProj4Definition;
